const NewsList = () => import('Views/news/news-list');
const NewsDetail = () => import('Views/news/news-detail-new-ui');

export default[
  { path: '/news-list', component: NewsList },
  { path: '/news-detail/:id', component: NewsDetail },
];



// WEBPACK FOOTER //
// ./src/router/news.js